export const UI_QUERY_KEY = {
  ALL_FILES: 'all_files',
}
